import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import 'broadcastchannel-polyfill';
import { Provider } from 'react-redux';
import { Router } from 'react-router-dom';
import { authenticationChannelReceiverFactory } from '../../core/middleware/authentication-channel-middleware';
import { buildSubscriptions as buildChannelSubscriptions } from './case-channel-subscriptions';
const popupFactory = (generatorProps)=>{
    const { store, history } = generatorProps;
    const currentURL = new URL(`${window?.top?.location}`);
    const subscriptions = buildChannelSubscriptions(currentURL);
    authenticationChannelReceiverFactory(subscriptions, store);
    return (appProps)=>{
        const { children } = appProps;
        return /*#__PURE__*/ _jsx(Provider, {
            store: store,
            children: /*#__PURE__*/ _jsx(Router, {
                history: history,
                children: children
            })
        });
    };
};
export { popupFactory };
